import React from 'react';
import 'react-phone-number-input/style.css'; // Styles de la librairie
import PhoneInput from 'react-phone-number-input';

const PhoneInputField = ({
    label,
    id,
    register,
    errors,
    setValue,
    placeholder = 'Numéro de téléphone',
    required = true,
}) => {

    const { ref } = register(`${id}Number`, {
        required: required ? 'Ce champ est requis' : false,
    });

    return (
        <div className="mb-4">
            <label htmlFor={`${id}Number`} className="block text-sm font-medium mb-2">
                {label} {required && <span className="text-red-500">*</span>}
            </label>
            <div className="flex items-center">
                <PhoneInput
                    international
                    ref={ref}
                    onChange={(value) => setValue(`${id}Number`, value)}
                    className={`py-3 px-4 border rounded-l-lg text-sm${errors[`${id}Number`] ? 'border-red-500' : 'border-gray-300'} focus:border-${errors[id] ? 'red' : 'gray'}-500 focus:ring-${errors[`${id}Number`] ? 'red' : 'gray'}-500`}
                    placeholder={placeholder}
                    required={required}
                    aria-label="Numéro de téléphone"
                />
            </div>
            {errors[`${id}Number`] && (
                <p className="text-red-500 text-sm mt-1">{errors[`${id}Number`].message}</p>
            )}
        </div>
    );
};

export default PhoneInputField;
